<template lang="pug">
div
  .row.padded.padded-y.d-flex.flex-row.header
    .d-flex.flex-row.mr-auto
      a.logo(href="/")
        img(src="@/assets/images/xendity-logo.png", alt="")
      h3.mx-4.my-auto SaaS Portal
    router-link.btn.mr-2(to="/portal/details", tag="button")
      i.fas.fa-user
    a.btn.btn-danger.mr-2.text-white(v-if="$store.getters.userRole == 'user'" download="SaaS API Docs.pdf" href="document.pdf") API Docs
    button.btn.btn-login.mr-2(@click="logout") Logout
  router-view
</template>

<script>
export default {
  methods: {
    logout() {
      this.$store.dispatch("user/logout").then((response) => {
        if (response.status == 400)
          this.$swal(response.error_message, "Error", "error");
        else this.$router.push("/");
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/portal.scss";
</style>